var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "lead-list-page" } },
    [
      _vm.showTitle
        ? _c("h3", { staticClass: "title" }, [_vm._v("Meta Leads")])
        : _vm._e(),
      _vm._v(" "),
      _vm.checkboxOption.selectedRowKeys.length
        ? _c("div", { staticClass: "selection-bar" }, [
            _c(
              "section",
              { staticClass: "uncheck", on: { click: _vm.unselectAll } },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" arrow_back "),
                ]),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("chatbotv2.uncheckAll")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "select", on: { click: _vm.selectAll } },
              [_vm._v(_vm._s(_vm.$t("chatbotv2.selectAll")))]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "select", on: { click: _vm.deleteAll } },
              [_vm._v(_vm._s(_vm.$t("search.integration.deleteAll")))]
            ),
            _vm._v(" "),
            _c("section", { staticClass: "queries" }, [
              _vm._v(
                "\n            +" +
                  _vm._s(
                    _vm.checkboxOption.selectedRowKeys.length +
                      " " +
                      _vm.$t("wp.contactSelected")
                  ) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "actions" },
              [
                _c(
                  "a-button",
                  { staticClass: "d-none", attrs: { ghost: "", disabled: "" } },
                  [_vm._v(_vm._s(_vm.$t("wp.sendBroadcastMessage")))]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "toolbox" }, [
        _c("div", [_vm._t("left-actions")], 2),
        _vm._v(" "),
        _c("div", [_vm._t("middle-actions")], 2),
        _vm._v(" "),
        _c("div", { staticClass: "buttons" }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c("div", { staticClass: "toolbar" }, [
            _c(
              "div",
              { staticClass: "toolbar-filter" },
              [
                _c("a-input-search", {
                  staticClass: "row search-input",
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: _vm.$t("message.search") },
                  on: {
                    input: function ($event) {
                      return _vm.onSearch($event.target.value)
                    },
                  },
                  model: {
                    value: _vm.searchText,
                    callback: function ($$v) {
                      _vm.searchText = $$v
                    },
                    expression: "searchText",
                  },
                }),
                _vm._v(" "),
                _c("CommonFilterTool", {
                  attrs: {
                    "keep-state-on-query-params": false,
                    "filter-meta": _vm.filterMetas,
                    "label-formatter": _vm.filterLabelFormatter,
                  },
                  on: { addFilter: _vm.addFilter },
                  model: {
                    value: _vm.breakdownFilter,
                    callback: function ($$v) {
                      _vm.breakdownFilter = $$v
                    },
                    expression: "breakdownFilter",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: { ghost: "", primary: "" },
                    on: { click: _vm.syncLeads },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("sync"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("message.syncLeeds")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getFilteredCols(),
              rows: _vm.leads,
              "top-pagination": "",
              "empty-data-bordered": "",
              "bottom-pagination": "",
              "pagination-cursor": _vm.pagination,
              "table-settings": true,
              options: {
                checkboxOption: _vm.checkboxOption,
                rowStyleOption: _vm.rowStyleOption,
                clipboardOption: _vm.clipboardOption,
                fixedHeader: true,
                id: "leads-table",
                borderX: true,
                borderY: true,
              },
            },
            on: {
              "cursor-changed": function (cursor) {
                return (_vm.pagination = cursor)
              },
              "table-settings": function ($event) {
                _vm.showColumnSettings = true
              },
            },
          }),
          _vm._v(" "),
          _vm.forbidden
            ? _c("NoMessage", {
                attrs: {
                  title: _vm.$t("message.forbiddenChannel"),
                  desc: _vm.$t("message.forbiddenChannelDesc"),
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              staticClass: "modal-wp-chat-starter",
              attrs: { "show-footer": false, title: _vm.$t("wpStartChat") },
              on: {
                cancel: function () {
                  return (_vm.showWhatsappChatStarterModal = false)
                },
              },
            },
            [
              _vm.selectedRow
                ? _c("WhatsappChatStarter", {
                    attrs: {
                      "default-phone-number": _vm.selectedRow.phone,
                      "channel-override": "",
                      "phone-number-override": "",
                      "default-email": _vm.selectedRow.email,
                      "default-name": _vm.selectedRow.name,
                    },
                    on: {
                      close: function () {
                        return (_vm.showWhatsappChatStarterModal = false)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showColumnSettings
        ? _c(
            "Modal2",
            {
              staticClass: "modal-column-settings",
              attrs: { "show-footer": false, title: "Tablo Ayarları" },
              on: {
                cancel: function ($event) {
                  _vm.showColumnSettings = false
                },
              },
            },
            [
              _c("div", { staticClass: "column-settings-content" }, [
                _c("div", { staticClass: "column-settings-header" }, [
                  _c("div", { staticClass: "header-info" }, [
                    _c("p", { staticClass: "description" }, [
                      _vm._v("Tabloda görmek istediğiniz kolonları seçin"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "quick-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass: "action-btn",
                        on: { click: _vm.deselectAllColumns },
                      },
                      [
                        _vm._v(
                          "\n                        Tümünü Kaldır\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "action-btn",
                        on: { click: _vm.resetToDefaultColumns },
                      },
                      [
                        _vm._v(
                          "\n                        Varsayılan\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column-list" }, [
                  _vm.availableColumns.filter(function (c) {
                    return c.required
                  }).length
                    ? _c("div", { staticClass: "column-group" }, [
                        _c("div", { staticClass: "group-title" }, [
                          _vm._v("Zorunlu Kolonlar"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "columns-grid" },
                          _vm._l(
                            _vm.availableColumns.filter(function (c) {
                              return c.required
                            }),
                            function (column) {
                              return _c(
                                "div",
                                {
                                  key: column.key,
                                  staticClass: "column-item disabled",
                                },
                                [
                                  _c(
                                    "a-checkbox",
                                    { attrs: { checked: true, disabled: "" } },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(column.title) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.availableColumns.filter(function (c) {
                    return !c.required
                  }).length
                    ? _c("div", { staticClass: "column-group" }, [
                        _c("div", { staticClass: "group-title" }, [
                          _vm._v("İsteğe Bağlı Kolonlar"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "columns-grid" },
                          _vm._l(
                            _vm.availableColumns.filter(function (c) {
                              return !c.required
                            }),
                            function (column) {
                              return _c(
                                "div",
                                { key: column.key, staticClass: "column-item" },
                                [
                                  _c(
                                    "a-checkbox",
                                    {
                                      attrs: {
                                        checked:
                                          _vm.getColumnVisibility(column),
                                      },
                                      on: {
                                        change: function (e) {
                                          return _vm.toggleColumn(
                                            column.key,
                                            e.target.checked
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(column.title) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "column-settings-footer" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        attrs: { ghost: "" },
                        on: {
                          click: function ($event) {
                            _vm.showColumnSettings = false
                          },
                        },
                      },
                      [_vm._v("\n                    İptal\n                ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.saveColumnSettings },
                      },
                      [_vm._v("\n                    Kaydet\n                ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }